<template>
  <v-container
    id="vue-grid-container"
    ref="container"
    class="d-flex flex-column align-stretch bg-white pa-0 ma-0 fill-height"
  >
    <v-row
      v-if="!_.isEmpty(datasetOptions)"
      class="flex-grow-0 ma-0 pa-0"
    >
      <v-col
        cols="6"
        class="text-left pt-0 pb-0"
        style="height:40px;"
      >
        <v-btn
          color="primary"
          @click="exportDataToCSV"
        >
          <v-icon
            left
            small
          >
            mdi-file-download
          </v-icon>
          <span class="caption">Export CSV</span>
        </v-btn>
        <reimport-dataset-btn
          :dataset="datasetOptions"
          class="ml-5"
          @update="tryFetchInit"
        />
      </v-col>
      <v-col
        cols="6"
        class="text-right pt-0 pb-0"
        style="height:40px;"
      >
        <v-spacer />
        <tap-execution
          v-if="tap"
          :tap_id="tap.id"
          @tapExecutionFinished="tapExecutionFinished"
        />
        <v-btn
          v-if="!is_read_only"
          small
          color="primary"
          @click.native="showInsertDialog = true"
        >
          <v-icon class="mr-1">
            mdi-plus
          </v-icon>
          New entry
        </v-btn>
        <v-menu
          offset-y
          :close-on-content-click="false"
          class="elevation-0"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="grey"
              text
              v-on="on"
            >
              <span class="caption">Show Columns&nbsp; </span>
              <v-icon
                right
                small
              >
                mdi-eye
              </v-icon>
            </v-btn>
          </template>
          <v-list
            class="pl-5 pr-5"
            style="overflow:auto;max-height:350px;"
          >
            <v-subheader class="pl-0 ml-0">
              Manage visible columns
            </v-subheader>
            <v-list-tile
              v-for="(item, index) in columns"
              :key="index"
            >
              <v-checkbox
                v-model="item.shown"
                color="grey"
                class="mt-0"
                :disabled="
                  item.shown &&
                    _.filter(columns, o => {
                      return (
                        o.shown && !_.isEqual(o, item)
                      );
                    }).length <= 0
                "
                @change="updateShowColumnsPreference(item)"
              >
                <template v-slot:label>
                  <div
                    class="text-truncate"
                    style="max-width:180px;"
                  >
                    {{ item.name }}
                  </div>
                </template>
              </v-checkbox>
            </v-list-tile>
          </v-list>
        </v-menu>
        <!-- show columns dropdown menu END -->
      </v-col>
    </v-row>
    <v-row class="flex-grow-1 ma-0 pa-0">
      <v-col cols="12">
        <div
          v-if="!inited"
          class="flex flex-column justify-center"
        >
          <spinner
            size="large"
            message="Loading..."
          />
        </div>
        <div
          v-else
          class="flex flex-column relative bg-white h-100 overflow-hidden"
        >
          <!-- grid header row handle -->
          <grid-header-row-handle
            v-if="inited"
            class="z-2 ba bg-near-white vg-td"
            :row-height="row_height"
            :row-handle-width="row_handle_width"
            @start-row-handle-resize="onStartRowHandleResize"
          />
          <!-- grid header -->
          <div
            class="flex-none bg-near-white vg-thead z-2"
            :style="
              'margin-left: ' +
                (row_handle_width +
                left_of_render_cols_width -
                scroll_left +
                4) +
                'px'
            "
          >
            <grid-header
              :row-handle-width="row_handle_width"
              :columns="render_cols"
              @select="handleSelection"
              @toggleDropdown="
                (col, state) => {
                  state
                    ? _.forEach(columns, o => {
                      if (_.isEqual(col, o))
                        o.showDropdown = true;
                      else o.showDropdown = false;
                    })
                    : (_.find(
                      columns,
                      col
                    ).showDropdown = false);
                }
              "
              @sort="handleHeaderSort"
              @applyFilter="handleHeaderApplyFilter"
              @start-column-resize="onStartColumnResize"
              @determine-cell-auto-width="initializeColumnWidths"
            />
          </div>

          <!-- row handles -->
          <div
            class="absolute z-99"
            :style="'top: ' + -scroll_top + 'px'"
          >
            <grid-row-handle
              class="ba bg-near-white vg-td"
              :row-index="0"
              :row-height="row_height"
              :row-handle-width="row_handle_width"
            />
            <grid-row-handle
              v-for="(row, index) in render_rows"
              :key="index"
              class="ba bg-near-white vg-td"
              :row-index="start + index + 1"
              :row-height="row_height"
              :row-handle-width="row_handle_width"
            >
              {{ start + index + 1 }}
            </grid-row-handle>
          </div>

          <div
            v-if="!is_read_only"
            class="absolute z-99"
            :style="
              'top: ' + -scroll_top + 'px;right:48px;width:37px'
            "
          >
            <grid-row-handle
              :key="'grid-row-handle-second-0'"
              class="ba bg-near-white vg-td"
              :row-index="0"
              :row-height="row_height"
              :row-handle-width="row_handle_width + 35"
            />
            <grid-row-handle
              v-for="(row, index) in render_rows"
              :key="index"
              :fixed-at-right="true"
              class="ba bg-near-white vg-td"
              :row-index="start + index + 1"
              :row-height="row_height"
              :row-handle-width="row_handle_width"
            >
              <div>
                <v-btn
                  style="margin:0 0;"
                  text
                  icon
                  small
                  color="grey"
                  @click="
                    editThisRow = row;
                    showEditDialog = true;
                  "
                >
                  <v-icon style="font-size:16px;">
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  style="margin:0 0;"
                  text
                  icon
                  small
                  color="grey"
                  @click="
                    confirmDelete = true;
                    deleteThisRow = row;
                  "
                >
                  <v-icon style="font-size:16px;">
                    mdi-delete-outline
                  </v-icon>
                </v-btn>
              </div>
            </grid-row-handle>
          </div>

          <!-- grid body -->
          <div
            ref="tbody"
            v-resize="onResize"
            class="flex-fill relative overflow-auto vg-tbody"
            :style="
              'margin-left: 51px;margin-right:' +
                (!is_read_only ? '85px' : '0px;')
            "
            @scroll="onScroll"
          >
            <!-- yardsticks -->
            <div
              class="absolute top-0 left-0"
              :style="
                'z-index: -1; width: 1px; height: ' +
                  total_height +
                  'px'
              "
            />
            <div
              class="absolute top-0 left-0"
              :style="
                'z-index: -1; height: 1px; width: ' +
                  total_width +
                  'px'
              "
            />

            <!-- rows -->
            <grid-row
              v-for="(row, index) in render_rows"
              :key="'grid-row-' + index"
              :selected="
                selectedRows.find(o => {
                  return o == index;
                }) >= 0
              "
              :row="row"
              :row-index="start + index"
              :row-height="row_height"
              :columns="render_cols"
              :style="
                'padding-left: ' +
                  left_of_render_cols_width +
                  'px'
              "
              @select="handleSelection"
              @determine-cell-auto-width="initializeColumnWidths"
            />
          </div>

          <v-dialog
            v-model="confirmDelete"
            persistent
            max-width="350"
          >
            <v-card>
              <v-card-title class="headline">
                Confirm your action ?
              </v-card-title>
              <v-card-text>
                Are you sure you want to delete this row ?
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="confirmDelete = false">
                  Cancel
                </v-btn>
                <v-btn
                  color="error"
                  @click="deleteRow"
                >
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <grid-handle-edit-create-row-dialog
            :show-dialog="showEditDialog"
            :dataset-id="datasetId"
            :columns="columns"
            :row="editThisRow"
            @applyEdition="handleApplyRowEdit"
            @close="
              editThisRow = {};
              showEditDialog = false;
            "
          />
          <grid-handle-edit-create-row-dialog
            :show-dialog="showInsertDialog"
            :dataset-id="datasetId"
            :columns="columns"
            :row="{}"
            :is-edit="false"
            @applyCreation="tryFetch(true)"
            @close="showInsertDialog = false"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {
    COLUMN_BTN_MENU_WIDTH_OFFSET,
    DEFAULT_START,
    DEFAULT_LIMIT,
    DEFAULT_ROW_HEIGHT,
    DEFAULT_ROW_HANDLE_WIDTH,
    ROW_HANDLE_MIN_WIDTH,
    ROW_HANDLE_MAX_WIDTH,
    DEFAULT_COLUMN_WIDTH,
    COLUMN_MIN_WIDTH,
    COLUMN_MAX_WIDTH,
  } from './constants'
  import DatasetService from './../../Dashboard/Views/Datastore/services/DatasetService'
  import TapExecution from "../../Dashboard/Views/Datastore/TapExecution";
  import _ from 'lodash'
  import axios from 'axios'
  import resize from 'vue-resize-directive'
  import GridHeaderRowHandle from './GridHeaderRowHandle.vue'
  import GridHeader from './GridHeader.vue'
  import GridRowHandle from './GridRowHandle.vue'
  import GridRow from './GridRow.vue'
  import Spinner from 'vue-simple-spinner'
  import GridCellCheckbox from './GridCellCheckbox'
  import GridHandleEditCreateRowDialog from './GridHandleEditCreateRowDialog'
  import ReimportDatasetBtn from './../../Dashboard/Views/Datastore/ReimportDatasetBtn'
  var getOffset = function (el) {
    var top = 0
    var left = 0

    do {
      if (!isNaN(el.offsetTop)) {
        top += el.offsetTop
      }
      if (!isNaN(el.offsetLeft)) {
        left += el.offsetLeft
      }
    } while ((el = el.offsetParent))

    return {
      left,
      top,
    }
  }

  export default {
    components: {
      ReimportDatasetBtn,
      GridHeaderRowHandle,
      GridHeader,
      GridRowHandle,
      GridRow,
      Spinner,
      GridCellCheckbox,
      GridHandleEditCreateRowDialog,
      TapExecution,
    },
    directives: {
      resize,
    },
    props: {
      reRenderKey: {
        type: Number,
        default: 0,
      },
      datasetId: {
        type: String,
        default: '',
      },
      tap: {
        type: Object,
        default: () => {
          return {}
        },
      },
      dataUrl: {
        type: String,
        default: '',
      },
      customHeaders: {
        type: Object,
        default: () => {
          return {}
        },
      },
      /* show empty cells on vertical scroll */
      liveScroll: {
        type: Boolean,
        default: false,
      },
      /* remove off-screen cells from the DOM on horizontal scroll */
      virtualScroll: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        uid: _.uniqueId('vue-grid-'),
        selectedRows: [],
        confirmDelete: false,
        deleteThisRow: null,
        editThisRow: {},
        showInsertDialog: false,
        showEditDialog: false,

        datasetOptions: {},

        inited: false,
        col_widths_inited: false,

        start: DEFAULT_START, // initial start
        limit: DEFAULT_LIMIT, // initial limit
        total_row_count: 0, // returned by query

        columns: [],
        resize_col: null,
        resize_row_handle: null,

        rows: [],
        cached_rows: {},
        row_height: DEFAULT_ROW_HEIGHT,
        row_handle_width: DEFAULT_ROW_HANDLE_WIDTH,

        client_height: 0,
        client_width: 0,

        container_offset_top: 0,
        container_offset_left: 0,

        offset_top: 0,
        offset_left: 0,
        offset_height: 0,
        offset_width: 0,

        scroll_top: 0,
        scroll_left: 0,

        mousedown_x: -1,
        mousedown_y: -1,
        mouse_x: 0,
        mouse_y: 0,

        is_horizontal_scroll_active: false,

        dataset: {},
      }
    },
    computed: {
      is_read_only () {
        if (!_.isEmpty(this.datasetOptions)) {
          const up = this.datasetOptions.user_permissions
          return this.datasetOptions.is_readonly
            ? true
            : !(
              up.includes('read_write_dataset') ||
              up.includes('owner_dataset')
            )
        }
        return false
      },
      grid_height () {
        return window.innerHeight - 330
      },
      total_height () {
        return this.row_height * this.total_row_count
      },
      total_width () {
        return _.sum(
          _.map(_.filter(this.columns, { shown: true }), 'pixel_width')
        )
      },
      rendered_row_count () {
        return _.size(this.rows)
      },
      cached_row_count () {
        return _.size(this.cached_rows)
      },
      first_visible_row () {
        return Math.floor(this.scroll_top / this.row_height)
      },
      last_visible_row () {
        return Math.min(
          Math.ceil(
            (this.scroll_top + this.client_height) / this.row_height
          ),
          this.total_row_count
        )
      },
      visible_row_count () {
        return this.last_visible_row - this.first_visible_row
      },
      rows_in_cache () {
        var missing_rows = false

        if (this.cached_row_count == 0) {
          return false
        }

        for (var i = this.start; i < this.start + this.limit; ++i) {
          if (i < this.total_row_count && !this.cached_rows[i]) {
            missing_rows = true
            break
          }
        }

        return !missing_rows
      },
      render_rows () {
        if (this.liveScroll) {
          return this.rows
        }

        var rows = []
        for (var i = this.start; i < this.start + this.limit; ++i) {
          if (i < this.total_row_count) {
            rows.push(this.cached_rows[i] || {})
          }
        }
        return rows
      },
      left_of_render_cols () {
        if (!this.virtualScroll) {
          return []
        }

        // this value should be an empty array since we're showing
        // all columns when scrolling horizontally
        if (this.is_potential_horizontal_scroll) {
          return []
        }

        var left = -1 * this.scroll_left
        return _.filter(this.columns, c => {
          var is_offscreen_left = left + c.pixel_width + 1 < 0
          left += c.pixel_width + 1
          return is_offscreen_left
        })
      },
      left_of_render_cols_width () {
        return _.sum(
          _.map(this.left_of_render_cols, c => {
            return c.pixel_width + 1
          })
        )
      },
      render_cols () {
        const columns = this.columns.filter(o => {
          return o.shown
        })
        if (!this.virtualScroll) {
          return columns
        }

        // horizontal scroll operations are far more performant with
        // all columns visible since this is a normal browser scroll event
        // and there are no expensive calculations that need to happen
        if (this.is_potential_horizontal_scroll) {
          return columns
        }

        // if we haven't yet initialized our column widths,
        // we need to return all columns so that the cells
        // are renderend and the cell contents can be measured
        if (!this.col_widths_inited) {
          return columns
        }

        var left = -1 * this.scroll_left
        return _.filter(columns, c => {
          var is_offscreen_left = left + c.pixel_width + 1 < 0
          var is_offscreen_right = left > this.client_width
          left += c.pixel_width + 1
          return !is_offscreen_left && !is_offscreen_right
        })
      },
      first_visible_column () {
        return _.first(this.render_cols)
      },
      last_visible_column () {
        return _.last(this.render_cols)
      },
      visible_column_count () {
        return _.size(this.render_cols)
      },
      total_column_count () {
        return _.size(this.columns)
      },
      resize_delta () {
        return this.mousedown_x == -1 ? 0 : this.mouse_x - this.mousedown_x
      },
      vertical_scrollbar_left () {
        return this.offset_left + this.client_width
      },
      vertical_scrollbar_right () {
        return this.offset_left + this.offset_width
      },
      horizontal_scrollbar_top () {
        return this.offset_top + this.client_height
      },
      horizontal_scrollbar_bottom () {
        return this.offset_top + this.offset_height
      },
      is_potential_horizontal_scroll () {
        if (this.is_horizontal_scroll_active) {
          return true
        }

        // handle bottom-right corner: if we're closer to the vertical
        // scrollbar than we are to the horizontal scrollbar, return 'false'
        if (
          this.mouse_x / this.vertical_scrollbar_left >
          this.mouse_y / this.horizontal_scrollbar_top
        ) {
          return false
        }

        // for the rest of the viewport, return 'true' when we get close
        // to the horizontal scrollbar
        if (
          this.mouse_y >= (this.horizontal_scrollbar_top * 2) / 3 &&
          this.mouse_y < this.horizontal_scrollbar_bottom
        ) {
          return true
        }

        return false
      },
      metrics () {
        var computed_data = this._computedWatchers
        computed_data = _.omit(computed_data, ['metrics'])
        computed_data = _.mapValues(computed_data, (k, v) => {
          return this[v]
        })

        var filtered_data = _.pick(this.$data, [
          'start',
          'limit',
          'rows',
          'total_row_count',
          'columns',
          'total_column_count',
          'cached_rows',
          'row_height',
          'row_handle_width',
          'mouse_x',
          'mouse_y',
          'scroll_top',
          'scroll_left',
          'offset_top',
          'offset_left',
          'offset_height',
          'offset_width',
          'client_height',
          'client_width',
          'total_height',
          'total_width',
        ])

        return _.assign({}, filtered_data, computed_data)
      },
    },
    watch: {
      reRenderKey (vnew, vold) {
        this.tryFetchInit()
      },
      scroll_top (val, old_val) {
        this.$emit('scroll-top-change', val, old_val)
      },
      scroll_left (val, old_val) {
        this.$emit('scroll-left-change', val, old_val)
      },
      total_height (val, old_val) {
        this.$emit('total-height-change', val, old_val)
      },
      rendered_row_count (val, old_val) {
        this.$emit('rendered-row-count-change', val, old_val)
      },
      cached_row_count (val, old_val) {
        this.$emit('cached-row-count-change', val, old_val)
      },
      total_row_count (val, old_val) {
        this.$emit('total-row-count-change', val, old_val)
      },
      first_visible_row (val, old_val) {
        this.$emit('first-visible-row-change', val, old_val)
      },
      last_visible_row (val, old_val) {
        this.$emit('last-visible-row-change', val, old_val)
      },
      visible_row_count (val, old_val) {
        this.$emit('visible-row-count-change', val, old_val)
      },
      first_visible_column (val, old_val) {
        this.$emit('first-visible-column-change', val, old_val)
      },
      last_visible_column (val, old_val) {
        this.$emit('last-visible-column-change', val, old_val)
      },
      visible_column_count (val, old_val) {
        this.$emit('visible-column-count-change', val, old_val)
      },
      metrics (val, old_val) {
        this.$emit('metrics-change', val, old_val)
      },
    },
    mounted () {
      this.dataset.hmd_id = this.datasetId
      this.dataset.tap = this.tap

      this.active_xhr = null
      this.cancelXhr = null
      this.default_col_widths = {}

      // initialize container offset
      var offset = getOffset(this.$refs.container)
      this.container_offset_top = offset.top
      this.container_offset_left = offset.left

      // initialize the client dimensions
      this.client_height = this.$el.clientHeight
      this.client_width = this.$el.clientWidth

      // establish our debounced and throttled methods (we need these functions
      // to be members of this component since we've run into reference
      // issues using _.debounce() and _.throttle() directly on the method
      this.tryFetchDebounced = _.debounce(this.tryFetch, 50, {
        leading: false,
        trailing: true,
      })
      this.resizeRowHandleThrottled = _.throttle(this.resizeRowHandle, 20)
      this.resizeColumnThrottled = _.throttle(this.resizeColumn, 20)
      // this.scrollVerticalThrottled = _.debounce(this.scrollVertical, 5, { leading: false, trailing: true })
      this.scrollVerticalThrottled = _.throttle(this.scrollVertical, 5, {
        leading: false,
        trailing: true,
      })

      // do our initial fetch
      this.tryFetchInit()

      // document-level mouse down
      this.onDocumentMousedown = evt => {
        this.closeDialogs(evt.target)
        this.mousedown_x = evt.pageX
        this.mousedown_y = evt.pageY
      }

      // document-level mouse up
      this.onDocumentMouseup = evt => {
        this.mousedown_x = -1
        this.mousedown_y = -1
        this.resize_col = null
        this.resize_row_handle = null
        // this.is_horizontal_scroll_active = false
        this.updateStyle('cursor', '')
        this.updateStyle('noselect', '')
      }

      // document-level mouse move
      this.onDocumentMousemove = evt => {
        this.mouse_x = evt.pageX
        this.mouse_y = evt.pageY

        if (!_.isNil(this.resize_row_handle)) {
          this.resizeRowHandleThrottled()
        }

        if (!_.isNil(this.resize_col)) {
          this.resizeColumnThrottled()
        }
      }

      // create document-level event handlers
      document.addEventListener('mousedown', this.onDocumentMousedown)
      document.addEventListener('mouseup', this.onDocumentMouseup)
      document.addEventListener('mousemove', this.onDocumentMousemove)
    },
    beforeDestroy () {
      // destroy document-level event handlers
      document.removeEventListener('mousedown', this.onDocumentMousedown)
      document.removeEventListener('mouseup', this.onDocumentMouseup)
      document.removeEventListener('mousemove', this.onDocumentMousemove)
    },
    methods: {
      closeDialogs (el) {
        if (
          document.getElementsByClassName('menuable__content__active')
            .length > 0 &&
          !el.closest('div.v-menu__content')
        ) {
          _.map(this.columns, (o, i) => {
            o.showDropdown = false
          })
        }
      },
      handleApplyRowEdit (editedRow) {
        console.log(editedRow)
        const found = _.find(this.cached_rows, this.editThisRow)
        if (found) {
          _.map(found, (o, i) => {
            found[i] = editedRow[i]
          })
        }
      },
      tapExecutionFinished(){
        this.$emit("tapExecutionFinished")
      },
      handleHeaderApplyFilter (col, filter) {
        _.find(this.columns, col).filter = filter
        if (filter.order != col.sortOrder) {
          col.sortOrder = filter.order
        }
        this.tryFetch(true)
      },
      handleHeaderSort (col, order) {
        _.find(this.columns, col).sortOrder = order
        this.tryFetch(true)
      },
      handleSelection (index) {
        if (index == -1) {
          if (this.selectedRows.length < this.render_rows.length) {
            this.selectedRows = _.map(this.render_rows, (o, i) => {
              return i
            })
          } else {
            this.selectedRows = []
          }
        } else {
          const found = this.selectedRows.find(o => {
            return o == index
          })

          if (found >= 0) {
            // remove
            this.selectedRows = this.selectedRows.filter(o => {
              return o != index
            })
          } else {
            this.selectedRows.push(index)
          }
        }
      },
      deleteRow () {
        const me = this
        DatasetService.deleteRow(
          me,
          this.dataset,
          me.deleteThisRow,
          me.columns
        )
          .then(r => {
            me.tryFetch(true)
          })
          .finally(() => {
            me.confirmDelete = false
            me.deleteThisRow = null
          })
      },
      editRow (row) {},
      submitEditedRow () {},
      updateShowColumnsPreference (field) {
        DatasetService.updateShowColumnsPreference(
          this,
          this.dataset,
          field
        )
      },
      exportDataToCSV () {
        DatasetService.exportDataToCSV(this, this.dataset)
      },
      tryFetchInit () {
        const me = this
        DatasetService.get(this.dataset, me)
          .then(r => {
            me.datasetOptions = r.data
            me.columns = _.map(r.data.fields, (o, i) => {
              return _.assign(
                {
                  pixel_width:
                    (window.innerWidth - 250) /
                    r.data.fields.length,
                  showDropdown: false,
                  sortOrder: '',
                  scale: null,
                  store_name: name,
                  width: null,
                },
                o
              )
            })
            this.tryFetch(true)
          })
          .catch(function (error) {
            if (!error.__CANCEL__) {
              me.$store.commit('push', {
                msg: 'error when getting the dataset info',
                color: 'error',
              })
            }
          })
      },
      tryFetch (clear) {
        var me = this
        const filter = []
        const sort = []
        const params = {
          // filter:[{
          //   field_name:'',
          //   query :{
          //   operator:"'lt', 'lte', 'gt', 'gte', 'in', 'like', 'contains'",
          //   values:['']
          //   }
          //   }
          // ]
        }

        // we need to get the start and limit before we do the AJAX call this the grid's
        // start and limit could potentially have changed by the time the callback resolves

        var fetch_start = this.start
        var fetch_limit = this.limit
        // if the last XHR is still active, kill it now
        if (!_.isNil(this.active_xhr) && !_.isNil(this.cancelXhr)) {
          this.cancelXhr()

          // reset XHR variables
          this.active_xhr = null
          this.cancelXhr = null
        }
        if (this.rows_in_cache && !clear) {
          return
        }

        _.map(this.columns, (c, i) => {
          if (c.sortOrder != '') { sort.push({ field_name: c.name, order: c.sortOrder }) }
          if (c.filter) {
            filter.push({
              field_name: c.name,
              is_filtered: true,
              query: {
                operator: c.filter.operator,
                values: [c.filter.value],
              },
            })
          }
        })
        if (sort.length) {
          params.sort = sort
        }
        if (filter.length) {
          params.filter = filter
        }
        params.limit = fetch_limit
        params.offset = fetch_start

        this.active_xhr = DatasetService.get_v1(this.dataset, params, {
          cancelToken: new axios.CancelToken(function (c) {
            me.cancelXhr = c
          }),
        })
          .then(r => {
            if (!r) {
              return
            }
            var resdata = r.data

            if (_.isNumber(resdata.count)) {
              me.total_row_count = resdata.count
            }

            // store the current set of rows
            me.rows = [].concat(resdata.results)

            // cache the current set of rows
            var start = fetch_start
            var limit = fetch_limit
            var row_count = me.total_row_count
            var temp_cached_rows = {}
            var idx = 0

            for (
              var r = start;
              r < start + limit && r < row_count;
              ++r
            ) {
              temp_cached_rows[r] = me.rows[idx]
              idx++
            }

            // add the temporary cached rows to our stored cached rows
            if (clear) {
              me.cached_rows = temp_cached_rows
            } else {
              me.cached_rows = _.assign(
                {},
                me.cached_rows,
                temp_cached_rows
              )
            }
            // set our init flag to true so we don't get columns after this
            me.inited = true

            // reset XHR variables
            me.active_xhr = null
            me.cancelXhr = null
          })
          .catch(function (error) {
            if (!error.__CANCEL__) {
              me.$store.commit('push', {
                msg: 'error when getting the dataset info',
                color: 'error',
              })
            }
          })
      },

      onStartRowHandleResize (col) {
        this.resize_row_handle = {
          old_width: this.row_handle_width,
        }
        this.updateStyle(
          'cursor',
          'html, body { cursor: ew-resize !important; }'
        )
        this.updateStyle(
          'noselect',
          'html, body { -moz-user-select: none !important; user-select: none !important }'
        )
      },

      onStartColumnResize (col) {
        this.resize_col = _.cloneDeep(col)
        this.updateStyle(
          'cursor',
          'html, body { cursor: ew-resize !important; }'
        )
        this.updateStyle(
          'noselect',
          'html, body { -moz-user-select: none !important; user-select: none !important }'
        )
      },

      onResize (resize_el) {
        var container_el = this.$refs.container
        this.offset_top = this.container_offset_top + resize_el.offsetTop
        this.offset_left =
          this.container_offset_left + resize_el.offsetLeft
        this.offset_height = resize_el.offsetHeight
        this.offset_width = resize_el.offsetWidth
        this.client_height = resize_el.clientHeight
        this.client_width = resize_el.clientWidth

        this.$nextTick(() => {
          // check to see if all of the visible rows have been queried for
          if (
            this.last_visible_row >=
            this.start + this.rendered_row_count
          ) {
            this.start = this.first_visible_row
            this.tryFetchDebounced()
          }
        })
      },

      onScroll () {
        var new_scroll_top = this.$refs.tbody.scrollTop
        var new_scroll_left = this.$refs.tbody.scrollLeft

        // vertical scrolls
        if (this.scroll_top != new_scroll_top) {
          return this.scrollVerticalThrottled(
            new_scroll_top,
            this.scroll_top
          )
        }

        // horizontal scrolls
        if (this.scroll_left != new_scroll_left) {
          return this.scrollHorizontal(new_scroll_left, this.scroll_left)
        }
      },

      scrollVertical (val, old_val) {
        this.scroll_top = val

        // scrolling down
        if (this.last_visible_row >= this.start + this.rendered_row_count) {
          this.start = this.first_visible_row
          this.tryFetchDebounced()
        }

        // scrolling up
        if (this.first_visible_row < this.start) {
          this.start = this.first_visible_row
          this.tryFetchDebounced()
        }
      },

      scrollHorizontal (val, old_val) {
        this.is_horizontal_scroll_active = true
        this.scroll_left = val
      },

      resizeRowHandle () {
        var old_width = this.resize_row_handle.old_width
        var new_width = old_width + this.resize_delta
        new_width = Math.max(ROW_HANDLE_MIN_WIDTH, new_width)
        new_width = Math.min(ROW_HANDLE_MAX_WIDTH, new_width)
        this.row_handle_width = new_width
      },

      resizeColumn () {
        var lookup_col = _.find(this.columns, {
          name: _.get(this.resize_col, 'name'),
        })
        if (!_.isNil(lookup_col)) {
          var temp_cols = _.map(this.columns, col => {
            if (_.get(col, 'name') == _.get(lookup_col, 'name')) {
              var old_width = _.get(
                this.resize_col,
                'pixel_width',
                DEFAULT_COLUMN_WIDTH
              )
              var pixel_width = old_width + this.resize_delta
              pixel_width = Math.max(COLUMN_MIN_WIDTH, pixel_width)
              pixel_width = Math.min(COLUMN_MAX_WIDTH, pixel_width)
              return _.assign({}, lookup_col, {
                pixel_width,
              })
            }

            return col
          })

          this.columns = [].concat(temp_cols)
        }
      },

      initializeColumnWidths (row_index, col, width) {
        // once we've initialized our column widths, we're done
        return
        if (this.col_widths_inited) {
        }

        var min_width = _.defaultTo(
          this.default_col_widths[col.name],
          COLUMN_MIN_WIDTH
        )
        var new_width = Math.min(min_width, width + 20) // make columns a little wider than they need to be
        new_width = Math.min(new_width, COLUMN_MAX_WIDTH)
        console.log(new_width)
        this.default_col_widths[col.name] = Math.max(
          this.client_width / this.columns.length - 68,
          new_width
        )

        var is_header = row_index == 'header'
        var is_last_row = row_index == this.rendered_row_count - 1

        if (is_header || is_last_row) {
          var temp_cols = _.map(this.columns, col => {
            var pixel_width =
              this.default_col_widths[col.name] +
              COLUMN_BTN_MENU_WIDTH_OFFSET
            if (_.isNaN(pixel_width)) {
              pixel_width = DEFAULT_COLUMN_WIDTH
            }
            return _.assign({}, col, {
              pixel_width,
            })
          })

          this.columns = [].concat(temp_cols)
          this.$nextTick(() => {
            this.col_widths_inited = true
          })
        }
      },

      updateStyle (id_suffix, style_str) {
        var head_el =
          document.head || document.getElementsByTagName('head')[0]
        var style_el = document.getElementById(this.uid + '-' + id_suffix)

        // a style with this ID already exists; remove it
        if (style_el) {
          head_el.removeChild(style_el)
        }

        // no style string specified; we're done
        if (!_.isString(style_str) || style_str.length == 0) {
          return
        }

        // add style to the <head>
        style_el = document.createElement('style')
        style_el.type = 'text/css'
        style_el.id = this.uid + '-' + id_suffix

        if (style_el.styleSheet) {
          style_el.styleSheet.cssText = style_str
        } else {
          style_el.appendChild(document.createTextNode(style_str))
        }

        head_el.appendChild(style_el)
      },
    },
  }
</script>

<style>
#vue-grid-container .gridHeaderCellLabel:hover {
    color: skyblue;
    text-decoration: underline;
}
#vue-grid-container .gridHeaderCellLabel {
    cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
#vue-grid-container .cursor-resize-ew:hover {
    width: 5px;
    background: #3ba99c;
}
#vue-grid-container .vg-th-inner > span,
#vue-grid-container .vg-td-inner > span {
    vertical-align: -webkit-baseline-middle;
}
#vue-grid-container .h-100.lh-1.tr.vg-td-inner {
    text-align: center;
}
#vue-grid-container .bg-near-white {
    background-color: #f3f3f3;
}
#vue-grid-container .gridHeaderCellMenuDropdown i {
    font-size: 18px;
}
#vue-grid-container .gridHeaderCellMenuDropdown {
    position: absolute;
    top: -26px;
    right: -10px;
}
#vue-grid-container .ba {
    border-style: solid;
    border-width: 1px;
}

#vue-grid-container .bt {
    border-top-style: solid;
    border-top-width: 1px;
}

#vue-grid-container .br {
    border-right-style: solid;
    border-right-width: 1px;
}

#vue-grid-container .bb {
    border-bottom-style: solid;
    border-bottom-width: 1px;
}

#vue-grid-container .b--black-20 {
    border-color: rgba(0, 0, 0, 0.2);
}

#vue-grid-container .b--black-10 {
    border-color: rgba(0, 0, 0, 0.1);
}

#vue-grid-container .top-0 {
    top: 0;
}

#vue-grid-container .right-0 {
    right: 0;
}

#vue-grid-container .bottom-0 {
    bottom: 0;
}

#vue-grid-container .left-0 {
    left: 0;
}

#vue-grid-container .absolute--fill {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

#vue-grid-container .db {
    display: block;
}

#vue-grid-container .dib {
    display: inline-block;
}

#vue-grid-container .flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

#vue-grid-container .flex-none {
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
}

#vue-grid-container .flex-column,
#vue-grid-container .flex-row {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-direction: normal;
}

#vue-grid-container .flex-row {
    -webkit-box-orient: horizontal;
    -ms-flex-direction: row;
    flex-direction: row;
}

#vue-grid-container .items-center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

#vue-grid-container .b {
    font-weight: 700;
}
#vue-grid-container .vg-td-inner,
#vue-grid-container .vg-th-inner {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
}

#vue-grid-container .fw6 {
    font-weight: 600;
}

#vue-grid-container .h3 {
    height: 4rem;
}

#vue-grid-container .h-100 {
    height: 100%;
}

#vue-grid-container .lh-copy {
    line-height: 1.5;
}

#vue-grid-container .w1 {
    width: 1rem;
}

#vue-grid-container .w-100 {
    width: 100%;
}

#vue-grid-container .overflow-hidden {
    overflow: hidden;
}

#vue-grid-container .overflow-auto {
    overflow: auto;
}

#vue-grid-container .relative {
    position: relative;
}

#vue-grid-container .absolute {
    position: absolute;
}

#vue-grid-container .fixed {
    position: fixed;
}

#vue-grid-container .dark-gray {
    color: #333;
}

#vue-grid-container .mid-gray {
    color: #555;
}

#vue-grid-container .light-silver {
    color: #aaa;
}

#vue-grid-container .white {
    color: #fff;
}

#vue-grid-container .blue {
    color: #357edd;
}

#vue-grid-container .bg-near-white {
    background-color: #f4f4f4;
}

#vue-grid-container .bg-white {
    background-color: #fff;
}

#vue-grid-container .bg-blue {
    background-color: #357edd;
}

#vue-grid-container .pa3 {
    padding: 1rem;
}

#vue-grid-container .pl2 {
    padding-left: 0.5rem;
}

#vue-grid-container .pr2 {
    padding-right: 0.5rem;
}

#vue-grid-container .pr3 {
    padding-right: 1rem;
}

#vue-grid-container .pv1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

#vue-grid-container .pv2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

#vue-grid-container .pv3 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}

#vue-grid-container .ph1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
}

#vue-grid-container .ph2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

#vue-grid-container .ph4 {
    padding-left: 2rem;
    padding-right: 2rem;
}

#vue-grid-container .ma3 {
    margin: 1rem;
}

#vue-grid-container .mr3 {
    margin-right: 1rem;
}

#vue-grid-container .mb3 {
    margin-bottom: 1rem;
}

#vue-grid-container .mt1 {
    margin-top: 0.25rem;
}

#vue-grid-container .mt2 {
    margin-top: 0.5rem;
}

#vue-grid-container .mh3 {
    margin-left: 1rem;
    margin-right: 1rem;
}

#vue-grid-container .collapse {
    border-collapse: collapse;
    border-spacing: 0;
}

#vue-grid-container .no-underline {
    text-decoration: none;
}

#vue-grid-container .tl {
    text-align: left;
}

#vue-grid-container .tr {
    text-align: right;
}

#vue-grid-container .tc {
    text-align: center;
}

#vue-grid-container .ttu {
    text-transform: uppercase;
}

#vue-grid-container .f5 {
    font-size: 1rem;
}

#vue-grid-container .f6 {
    font-size: 0.875rem;
}

#vue-grid-container .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
}

#vue-grid-container .nowrap,
#vue-grid-container .truncate {
    white-space: nowrap;
}

#vue-grid-container .v-top {
    vertical-align: top;
}

#vue-grid-container .underline-hover:focus,
#vue-grid-container .underline-hover:hover {
    text-decoration: underline;
}

#vue-grid-container .z-1 {
    z-index: 1;
}

#vue-grid-container .z-2 {
    z-index: 2;
}

#vue-grid-container .vg-container {
    font-family: Arial, sans-serif;
    font-size: 13px;
    color: #333;
}

#vue-grid-container .vg-thead {
    box-shadow: none !important;
}

#vue-grid-container .vg-td,
#vue-grid-container .vg-th {
    margin-top: -1px;
    margin-left: -1px;
    padding-top: 1px;
    border-color: #ddd;
}

#vue-grid-container .vg-td-inner,
#vue-grid-container .vg-th-inner {
    padding: 4px 5px;
}

#vue-grid-container .flex-fill {
    -ms-flex: 1 1;
    flex: 1 1;
    min-width: 0;
    min-height: 0;
}

#vue-grid-container .b--light-moon-gray {
    border-color: #ddd;
}

#vue-grid-container .lh-1 {
    line-height: 1;
}

#vue-grid-container .cursor-resize-ew {
    cursor: ew-resize;
    -webkit-transition: all 300ms ease;
    -moz-transition: all 300ms ease;
    -ms-transition: all 300ms ease;
    -o-transition: all 300ms ease;
    transition: all 300ms ease;
}
.z-99 {
    z-index: 3;
}
</style>
